<template lang="pug">
b-modal#getRollbackDetail(
  ref="getRollbackDetail"
  :title="$t('ui.combine.get_rollback_detail')"
  centered
  no-fade
  no-close-on-backdrop
  size="xl"
  :busy="loading"
  ok-only
  @show="reset"
  @shown="shown"
)
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .clusterize-scroll.table-responsive
      table.table.table-sm.table-bordered.table-striped.table-hover
        thead.thead-light
          tr
            th.text-center(width="5%")
              span #
            th(width="15%")
              span(:title="$t('ui.sender_bank')") {{ $t('ui.short.sender_bank') }}
            th(width="15%")
              span(:title="$t('ui.sender_bank_acc_no')") {{ $t('ui.short.sender_bank_acc_no') }}
            th(width="15%")
              span(:title="$t('ui.sender_bank_acc_holder')") {{ $t('ui.short.sender_bank_acc_holder') }}
            th.text-center(width="10%")
              span(:title="$t('ui.status')") {{ $t('ui.status') }}
            th(width="15%")
              span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
            th.text-right(width="10%")
              span(:title="$t('ui.created_by')") {{ $t('ui.created_by') }}
            th.text-right(width="15%")
              span(:title="$t('ui.created_date')") {{ $t('ui.created_date') }}
        tbody
          tr(v-if="rollbackList.length == 0")
            td(colspan="8").text-center
              span {{ $t('message.no_data_available') }}
          tr(v-for="(item, index) in rollbackList")
            td.text-center
              span(:title="index + 1") {{ index + 1 }}
            td
              span(:title="item.sender_bank_id") {{ item.sender_bank_id }}
            td
              span(:title="item.sender_bank_acc_no") {{ item.sender_bank_acc_no }}
            td
              span(:title="item.sender_bank_acc_holder") {{ item.sender_bank_acc_holder }}
            td.text-center
              span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status.trim().toUpperCase() }}
            td
              span(:title="item.remark") {{ item.remark }}
            td.text-right
              span(:title="item.created_by") {{ item.created_by }}
            td.text-right
              span(v-if="item.created_date" :title="$moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.created_date).format('YYYY-MM-DD, HH:mm:ss') }}
    //- div.row
    //-   div.col
    //-     b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
  div(slot="modal-ok")
    SubmitButton(:loading="loading" icon="fas fa-check" :text="$t('ui.ok')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, requiredIf } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      account_id: '',
      rollbackList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {  },
  methods: {
    getRollbackDetail: function() {
      let url = config.ticketWithdrawalRollbackDetailFreeUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        ticket_id: this.item.id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.rollbackList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.account_id = this.item.member_id;
      this.getRollbackDetail();
    }
  }
};
</script>
